import React, { useState, useEffect } from "react";
import im from "../Media/supermarkets.png";
import MainImage from "../Components/MainImage";
import { Typography, Box, Stack } from "@mui/material";
import SmallBtns from "../Components/SmallBtns";
import i from "../Media/super-markets.png";
import OurGoal from "../Components/OurGoal";
import Questions from "../Components/Questions";
import db from "../DbFile.json";
import ServicesCard from "../Components/ServicesCard";
import { useTranslation } from "react-i18next";

export default function GetAnyThing({ setTheState }) {
  const [el, setEl] = useState(db.first_array);
  const [Qs, setQs] = useState(db.SMarket_Q);
  const { t } = useTranslation();
  useEffect(() => {
    setTheState(false);
  }, []);
  return (
    <div>
      <MainImage
        image={im}
        txt1={"EveryThing on your"}
        txt2={"list and more"}
      />
      <Box
        gap={4}
        sx={{
          marginTop: "3%",
          marginBottom: "4%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <SmallBtns txt={"SUPERMARKET"} name={"GetAnyThing"} />
        <SmallBtns txt={"Delivery"} name={"Delivary"} />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontSize: "30px", color: "#1D2877", fontWeight: "bold" }}
        >
          {t("SuperMarkets")}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontSize: "20px", color: "#1D2877" }}>
          {t("Order from shops you love, with a few taps.")}
        </Typography>
      </Box>
      <OurGoal
        im={i}
        caption={"From supermarket to table, simple."}
        btn={"Book your ride"}
        txt={
          "Shop everyday essentials ,order groceries online and have them delivered directly"
        }
      />
      <Box
        sx={{
          marginTop: "5%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "40px",
              color: "#1D2877",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {t("Explore more with Mashawiri")}
          </Typography>
          {el && <ServicesCard el={el.filter((el) => el.id !== 3)} />}
        </Stack>
      </Box>
      <Questions questions={Qs} />
    </div>
  );
}
